export default __webpack_public_path__ + "static/media/ktf.3b4db576.svg";